import { Controller } from 'stimulus'
import { useDebounce, useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['submitButton', 'form']
  static debounces = ['triggerFilter']

  connect() {
    useDebounce(this, { wait: 800 })
    useDispatch(this)
    this.formTarget.addEventListener('filters-container:filterCleared', this.triggerFilter.bind(this), {})
  }

  triggerFilter() {
    this.submitButtonTarget.click()
    this.dispatch('dataSearched', {
      filters_applied: $.deparam($(this.formTarget).serialize())
    }
    )
  }
}
